import React from 'react';
import {
    HeroImage,
    openInSameWindow,
    StaticPageLoadingPlaceholder,
    useAnalyticsErrorPageTracker,
} from '@cp-shared-15/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { useNotFoundErrorPage } from './useNotFoundErrorPage';

const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);

export const NotFoundErrorPage: React.FC = () => {
    const { cmsContent: notFoundErrorPage, isLoading, loadingError } = useNotFoundErrorPage();

    useAnalyticsErrorPageTracker('notFoundError', !!notFoundErrorPage);

    return (
        <HeroImageWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            title={notFoundErrorPage?.title || ''}
            subTitle={notFoundErrorPage?.subTitle}
            buttonText={notFoundErrorPage?.buttonText}
            clickHandler={openInSameWindow(notFoundErrorPage?.buttonUrl)}
            inverted
            loadingPlacehloder={
                <StaticPageLoadingPlaceholder withPretitle withSubTitle withButton>
                    <></>
                </StaticPageLoadingPlaceholder>
            }
        />
    );
};
